import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from '@vercel/analytics';
import { trackPageView, trackFacebookEvent, trackGoogleEvent, trackGoogleAdsConversion } from '@/lib/marketing';

export function useMarketingTracking() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
}

export function useConversionTracking() {
  const trackTrialBooking = () => {
    trackFacebookEvent('Lead', { content_name: 'Trial Class Booking' });
    trackGoogleEvent('trial_booking', { method: 'website' });
    trackGoogleAdsConversion();
    track('Book Trial Click');
  };

  const trackContactForm = () => {
    trackFacebookEvent('Contact', { content_name: 'Contact Form Submission' });
    trackGoogleEvent('contact_form_submit', { method: 'website' });
    track('Contact Form Submit', { method: 'website' });
  };

  const trackNewsletterSignup = (source: string = 'popup') => {
    trackFacebookEvent('Lead', { content_name: 'Newsletter Signup', source });
    trackGoogleEvent('newsletter_signup', { method: source });
    trackGoogleAdsConversion();
    track('Newsletter Signup', { source });
  };

  const trackProgramView = (programName: string) => {
    trackFacebookEvent('ViewContent', { content_name: programName, content_category: 'Program' });
    trackGoogleEvent('view_program', { program_name: programName });
  };

  const trackScheduleView = () => {
    trackFacebookEvent('ViewContent', { content_name: 'Schedule', content_category: 'Page' });
    trackGoogleEvent('view_schedule', { method: 'website' });
  };

  const trackPhoneCall = () => {
    trackFacebookEvent('Contact', { content_name: 'Phone Call', method: 'tel_link' });
    trackGoogleEvent('phone_call_click', { method: 'website' });
    track('Phone Call Click', { method: 'tel_link' });
  };

  return {
    trackTrialBooking,
    trackContactForm,
    trackNewsletterSignup,
    trackProgramView,
    trackScheduleView,
    trackPhoneCall,
  };
}


